import { render, staticRenderFns } from "./Resourcesa.vue?vue&type=template&id=a91f8e82&scoped=true&"
import script from "./Resourcesa.vue?vue&type=script&lang=js&"
export * from "./Resourcesa.vue?vue&type=script&lang=js&"
import style0 from "./Resourcesa.vue?vue&type=style&index=0&id=a91f8e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91f8e82",
  null
  
)

export default component.exports